import { useEffect, useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import { FieldArray, Formik } from "formik";

import _ from 'lodash';

import { ValueDatatypeList } from "../../models/config.model";
import { PredictionModelModel } from "../../models/predictionModel.model";

import { HeaderRegister } from "../../components/HeaderRegister";
import { ColorPicker } from "../../components/ColorPicker";
import { FormDynamicControl } from "../../components/FormDynamicControl";

import PredictionModelConfigService from "../../services/predictionModelConfig.service";
import PredictionModelService from "../../services/predictionModel.service";
import { ToastService } from "../../services/toast.service";
import UtilService from "../../services/util.service";
import storageService from "../../services/storage.service";
import ModalNewModel from "../../components/ModalNewModel";
import { DatasetDefault } from '../../models/dataset.model';
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault} from '../../models/requestInputOutputParams.model';
import { init } from "i18next";
import { FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import styled from 'styled-components';
import TooltipDescriptionService from "../../services/tooltipDescription.service";

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip-content {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipContent = styled.div`
  visibility: hidden;
  width: 350px;
  background-color: white;
  color: black;
  text-align: left;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
  position: absolute;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;

  &.adjust-left {
    left: auto;
    right: 0;
    transform: translateX(10px);
  }

  &.adjust-right {
    left: 0;
    transform: translateX(-10px);
  }

  &.adjust-top {
    bottom: calc(100% + 10px);
    transform: translateY(-10px);
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent white transparent;

    &.adjust-left {
      left: auto;
      right: 10px;
      transform: translateX(0);
    }

    &.adjust-right {
      left: 10px;
      transform: translateX(0);
    }

    &.adjust-top {
      bottom: 100%;
      top: auto;
      border-color: white transparent transparent transparent;
    }
  }

  hr {
    border: 1px solid #ddd;
    margin: 8px 0;
  }

  .description {
    color: blue;
  }
`;


export const ModelRegister = () => {
  
  const [initialValues, setInitialValues] = useState({
    predictionModelId: undefined,
    localeId: undefined,
    nameModel: undefined,
    equipmentConfig: []
  });

  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const formRef = useRef();
  const [showNewModel, setShowNewModel] = useState(false);
  const [nameNewModel, setNameNewModel] = useState("");
  const [deleteCheckReference, setDeleteCheckReference] = useState(0); // 0 - None Selected, 1 - Ok, 2 - Default Model, 3 - Equipments Attached
  const [baseId, setBaseId] = useState(0);
  const [showMainParameters, setShowMainParameters] = useState(false);

  const user = storageService.getUser();
  const [tooltipDescription, setTooltipDescription] = useState<string>('');
  const tooltipRef = useRef(null);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [adjustTooltipClass, setAdjustTooltipClass] = useState('');

  const [predictionModels, setPredictionModels] = useState<PredictionModelModel[]>();
  const fetchTooltipDescription = async (fieldId) => {
    try {
      const storedTooltip = localStorage.getItem(`tooltip_${fieldId}_${user.localeId}`);
      if (storedTooltip) {
        const { tooltipDescription: storedDescription } = JSON.parse(storedTooltip);
        setTooltipDescription(storedDescription);
      } else {
        const resp = await TooltipDescriptionService.GetByFieldLocale(fieldId, user.localeId);
        if (resp['success']) {
          const newDescription = resp['result'];
          setTooltipDescription(newDescription);
          localStorage.setItem(`tooltip_${fieldId}_${user.localeId}`, JSON.stringify({ tooltipDescription: newDescription }));
        } else {
          console.error("Erro ao obter a descrição do Tooltip:", resp && resp['messages']);
          setTooltipDescription('');
        }
      }
    } catch (error) {
      console.error("Erro na requisição do Tooltip:", error);
      setTooltipDescription('');
    }
  };
  const adjustTooltipPosition = () => {
    if (tooltipRef.current) {
      const tooltip = tooltipRef.current;
      const tooltipRect = tooltip.getBoundingClientRect();
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      let newClass = '';

      // Check if the tooltip is out of the viewport horizontally
      if (tooltipRect.right > screenWidth) {
        newClass += ' adjust-left';
      } else if (tooltipRect.left < 0) {
        newClass += ' adjust-right';
      }

      // Check if the tooltip is out of the viewport vertically
      if (tooltipRect.bottom > screenHeight) {
        newClass += ' adjust-top';
      }

      setAdjustTooltipClass(newClass.trim());
    }
  };

  useEffect(() => {
    if (isTooltipVisible) {
      adjustTooltipPosition();
    }
  }, [isTooltipVisible]);

  const initialize = async () => {
    setLoading(true);
    await PredictionModelService.getAll().then((response: any) => {
      setPredictionModels(response.result);
    });
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  };

  const returnDisplay = (valueDatatype: string) => {
    if (valueDatatype == "D" || valueDatatype == "N" || valueDatatype == "I") {
      return "block";
    } else {
      return "none";
    }
  };

  const handleChangeDate = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatDate(evt, "yyyy-MM-dd")
      }
    });
  };

  const handleChangeDateRange = (dataInicio: any, dataFim: any, index: number, data: any) => {

    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatDate(dataInicio, "yyyy-MM-dd") + "|" + UtilService.formatDate(dataFim, "yyyy-MM-dd");
      }
    });
  };

  const handleChangeColor = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.color = evt.hex;
      }
    });
  };

  const handleChangeDateTime = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatDateTime(evt, "yyyy-MM-dd HH:mm:ss")
      }
    });
  };

  const handleChangeMoney = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatNumber(evt);
      }
    });
  }  

  const handleChangeMoneyRange = (valorInicio: any, valorFim: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatNumber(valorInicio) + "|" + UtilService.formatNumber(valorFim);
      }
    });
  };

  const handleChangeNumberRange = (valorInicio: any, valorFim: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.onlyNumber(valorInicio) + "|" + UtilService.onlyNumber(valorFim);
      }
    });
  };

  const handleChangeNumber = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.onlyNumber(evt);
      }
    });
  };

  const handleNewModelClick = () => {
    setShowNewModel(true);
  }

  const handleChangeNewModelName = (event) => {
    setNameNewModel(event.target.value);
  }

  const handleChangeCheckMainParameters = (event) => {
    setShowMainParameters(event.target.checked);
  }

  const sleep = ms => new Promise(r => setTimeout(r, ms));
  
  const handleDeleteClick = async () => {
    if (deleteCheckReference == 0)
      ToastService.error(t("MODEL.NO_MODEL_SELECTED"));
    else if (deleteCheckReference == 2)
      ToastService.error(t("MODEL.DEFAULT_MODEL_SELECTED"));
    else if (deleteCheckReference == 3)
      ToastService.error(t("MODEL.EQUIPMENT_USING_MODEL"));
    else
    {

      try {
        const response: any = await await PredictionModelService.trash(baseId);
          if (response.success) {
            ToastService.success(t('MODEL.DELETED_MODEL_SUCCESS'));
            setBaseId(0);
            setDeleteCheckReference(0);
            initialize();
           
          }
      } catch (error) {
          ToastService.error(t('ERROR_GENERIC'));
      };
      await sleep(2000);
      window.location.reload();
    }
  }

  const handleSaveNewModelClick = async () => {
    setShowNewModel(false);
    const payload = {
      ...JSON.parse(JSON.stringify(DatasetDefault)),
      dataset: 'model',
      data: [{newname: nameNewModel}],
    };

    let reqData: RequestInputOutputParamsModel = {
      ...RequestInputOutputParamsModelDefault,
      datasets: [payload],
    };

    try {
    const response: any = await await PredictionModelService.insert(reqData);
      if (response.success) {
        ToastService.success(t('MODEL.UPDATED'));
        initialize();
      }
    } catch (error) {
      ToastService.error(t('ERROR_GENERIC'));
    }
    
  }

  const onSubmit = async (date) => {
    try {
      if (date.predictionModelId == undefined) {
        ToastService.warn(t('MODEL.ALERT_MODE'), null);
        return;
      }
      date.Id = date.predictionModelId;
      date.FullName = date.nameModel;
      const response: any = await PredictionModelConfigService.UpdatePredictionModel(date);
      if (response.success) {
        ToastService.success(t('MODEL.UPDATED'));
        initialize();
      }
    } catch (error) {
      ToastService.error(t('ERROR_GENERIC'));
    }
  };

  const getOrdenedConfigList = (list) =>{

    //list = list.filter(x => x.isEquipmentConfig === true);
    
    // Pegar as descrições da tradução atual
    list.map((item)=>{
        return item.configDescription = t('CONFIG.' + item.configKey.toUpperCase()).toString().trimEnd();
    });

    // Ordenar a lista
    list.sort((a, b) => {
        const nameA = a.configDescription.toUpperCase(); // ignore upper and lowercase
        const nameB = b.configDescription.toUpperCase(); // ignore upper and lowercase

        const keyA = a.configKey.toUpperCase(); // ignore upper and lowercase
        const keyB = b.configKey.toUpperCase(); // ignore upper and lowercase

        if (a.isRange && !b.isRange)
        {
            return 1;
        }
        if (b.isRange && !a.isRange)
        {
            return -1;
        }
        if (a.isRange && b.isRange)
        {
            if (keyA < keyB)
                return -1;
            else if (keyB > keyA)
                return 1;
            else
                return 0;
        }
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    });
    


    //  Deixar os 3 valores por primeiro    

    const monetary_limit = list.find(x=>x.configKey.toLowerCase() == 'monetary_limit');
    const monetary_limit_index = list.findIndex(x=>x.configKey.toLowerCase() == 'monetary_limit');
    list.splice(monetary_limit_index,1);  

    const limit_contractual = list.find(x=>x.configKey.toLowerCase() == 'limit_contractual');
    const limit_contractual_index = list.findIndex(x=>x.configKey.toLowerCase() == 'limit_contractual');
    list.splice(limit_contractual_index,1);  

    const physical_limit = list.find(x=>x.configKey.toLowerCase() == 'physical_limit');
    const physical_limit_index = list.findIndex(x=>x.configKey.toLowerCase() == 'physical_limit');
    list.splice(physical_limit_index,1);  

    const limit_contractual_original = list.find(x=>x.configKey.toLowerCase() == 'limit_contractual_original');
    const limit_contractual_original_index = list.findIndex(x=>x.configKey.toLowerCase() == 'limit_contractual_original');
    list.splice(limit_contractual_original_index,1);


    list.unshift(limit_contractual_original);
    list.unshift(physical_limit);
    list.unshift(limit_contractual);
    list.unshift(monetary_limit);

    return list;

  }

  return (
    <>
      <HeaderRegister
        title={`${t('MODEL.TITLE')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`}
        path={"/Models"}
        submitForm={submitFormik}
        isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
        btnBack={false}
        customBtnLabel={t('BUTTON_NEW')}
        customBtnFunction={handleNewModelClick}
        customRightBtnLabel={t('DELETE')}
        customRightBtnFunction={handleDeleteClick}
        mainCheckLabel={t('MODEL.SHOW_MAIN_PARAMETERS')}
        mainCheckFunction={handleChangeCheckMainParameters}
      />

      <ModalNewModel 
          show={showNewModel} 
          close={() => setShowNewModel(false)}
          save={handleSaveNewModelClick}
          changeValue={handleChangeNewModelName}
      />

      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setValues
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} xl={12}>
                <Row className="align-items-center">
                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='predictionModelId'
                          name='predictionModelId'
                          isInvalid={touched.predictionModelId && !!errors.predictionModelId}
                          disabled={isLoading}
                          onChange={(event) => {
                            let value = event.target.value;
                            if (value) {
                              PredictionModelConfigService.getByPredictionModel(event.target.value).then((response: any) => {

                                setValues(prev => ({
                                  ...prev,
                                  equipmentConfig: []   // limpa lista completamente
                                }));

                                const newList = Array.isArray(response.result.data)
                                  ? response.result.data
                                  : [];

                                const ordered = getOrdenedConfigList(newList);

                                setValues(prevValues => ({
                                  ...prevValues,
                                  predictionModelId: value,
                                  localeId: response.result.localeId,
                                  nameModel: response.result.name,
                                  equipmentConfig: ordered
                                }));
                                setBaseId(Number(value));
                                setDeleteCheckReference(!response.result.localeId ? 2 : (response.result.equipmentCount ? 3 : 1))
                              });
                              
                            } else {
                              setValues(prevValues => ({
                                ...prevValues,
                                predictionModelId: value,
                                localeId: 0,
                                nameModel: '',
                                equipmentConfig: []
                              }));
                              setBaseId(0);
                              setDeleteCheckReference(0);
                            }
                          }}
                          value={values.predictionModelId}
                          aria-label={t("EQUIPMENT.MODEL")}>
                          <option value=''>{t("EQUIPMENT.MODEL")}</option>
                          {_.map(predictionModels, (l: PredictionModelModel) => {
                            return <option key={l.id} value={l.id}>{l.localeId == 0 ? t("PREDICTIONMODEL." + l.fullName.toUpperCase()) : l.fullName}</option>
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.predictionModelId}
                        </Form.Control.Feedback>
                        <label htmlFor="predictionModelId">{t("EQUIPMENT.MODEL")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating hidden={!values.localeId}>
                        <Form.Control
                                      id='nameModel'
                                      name='nameModel'
                                      type='text'
                                      value={values.nameModel}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={!values.localeId}
                                      maxLength={20}
                                    />
                        <label htmlFor="nameModel">{t("EQUIPMENT.MODEL")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <h6>{t("EQUIPMENT.CONFIGS")}</h6>
                  <hr/>
                  <FieldArray
                    name="equipmentConfig"
                    render={() => (
                      <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, minmax(50px, 1fr))', gridGap: '1rem', width: 'fit-content'}}>
                        {values.equipmentConfig && values.equipmentConfig.length > 0 && (
                          values.equipmentConfig.map((ec, index) => (
                            <Row key={index} hidden={!values.equipmentConfig[index].isMainParameter && showMainParameters}>

                              <Col xs='12' sm='12' md='6' lg='4' className="mb-4" style={{display: 'flex'}}>
                                <span className="pb-2" style={{ display: 'inline-block', alignSelf: 'flex-end', height: '40px'}}>
                                  {values.equipmentConfig[index].configDescription}
                                  <TooltipContainer  
                                      key={index}
                                      onMouseOver={() => {
                                        fetchTooltipDescription(values.equipmentConfig[index].generalFieldTranslatorId);
                                        setTooltipVisible(true);
                                      }}
                                      onMouseOut={() => {
                                        setTooltipVisible(false);
                                        setAdjustTooltipClass('');
                                      }}
                                      >
                                        <FontAwesomeIcon icon={faCircleQuestion} className="pt-2 pl-1"  />
                                         <TooltipContent ref={tooltipRef} className={`tooltip-content ${adjustTooltipClass}`}>
                                        <strong>{values.equipmentConfig[index].configKey}</strong>
                                        <hr />
                                        <div className="description">
                                          {tooltipDescription ? tooltipDescription : t('LOADING_TOOLTIP_DESCRIPTION')}
                                        </div>
                                      </TooltipContent>

                                      </TooltipContainer>
                                </span>
                              </Col>

                              <Col xs='12' sm='12' md='6' lg='4' className="mb-4">
                                <Form.Group>
                                  <Form.Floating>
                                    <FormDynamicControl
                                      id={`equipmentConfig.${index}.configValue`}
                                      index={values.equipmentConfig[index].id}
                                      name={`equipmentConfig.${index}.configValue`}
                                      dataType={values.equipmentConfig[index].valueDatatype}
                                      data={values}
                                      disabled={isLoading}
                                      value={values.equipmentConfig[index].configValue}
                                      placeholder={t('EQUIPMENT.CONFIG_VALUE')}
                                      onChange={handleChange}
                                      handleChangeDate={handleChangeDate}
                                      handleChangeDateTime={handleChangeDateTime}
                                      handleChangeDateRange={handleChangeDateRange}
                                      handleChangeNumber={handleChangeNumber}
                                      handleChangeNumberRange={handleChangeNumberRange}
                                      handleChangeMoneyRange={handleChangeMoneyRange}
                                      handleChangeMoney={handleChangeMoney}
                                      type='text'
                                      label={t('EQUIPMENT.CONFIG_VALUE')}
                                      labelRangeMin={t('FILTER.CONFIG_VALUE_MIN_REDUCED')}
                                      labelRangeMax={t('FILTER.CONFIG_VALUE_MAX_REDUCED')}
                                      isRange={values.equipmentConfig[index].isRange}
                                    />
                                  </Form.Floating>
                                </Form.Group>
                              </Col>

                              <Col hidden={true} xs='auto' sm='auto' md='auto' lg='auto' className="mb-4">
                                <Form.Group>
                                  <Form.Floating>
                                    <Form.Select
                                      id={`equipmentConfig.${index}.valueDatatype`}
                                      name={`equipmentConfig.${index}.valueDatatype`}
                                      disabled={isLoading || true}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.equipmentConfig[index].valueDatatype}
                                      aria-label={t("CONFIG.VALUEDATATYPE")}>
                                      <option value="">{t("CONFIG.VALUEDATATYPE")}</option>
                                      {_.map(ValueDatatypeList, (i) => {
                                        return <option key={i.id} value={i.id}>{t('CONFIG.' + i.name.toUpperCase())}</option>
                                      })}
                                    </Form.Select>
                                    <label htmlFor="valueDatatype">{t("CONFIG.VALUEDATATYPE")}</label>
                                  </Form.Floating>
                                </Form.Group>
                              </Col>

                              {values.equipmentConfig[index].isEquipmentConfig &&
                                <Col hidden={true} xs='auto' sm='auto' md='auto' lg='auto' className="mb-4">
                                  <Form.Group>
                                    <Form.Check
                                      id={`equipmentConfig.${index}.isEquipmentConfig`}
                                      name={`equipmentConfig.${index}.isEquipmentConfig`}
                                      type='checkbox'
                                      checked={values.equipmentConfig[index].isEquipmentConfig}
                                      onChange={handleChange}
                                      disabled={true}
                                    />
                                    <Form.Label>{t('EQUIPMENT.CONFIG_IS_EQUIPMENT_CONFIG')}</Form.Label>
                                  </Form.Group>
                                </Col>
                              }
                              {values.equipmentConfig[index].color &&
                                 <Col xs='auto' sm='auto' md='auto' lg='auto' className="mb-4">
                                  <Form.Group>
                                    <Form.Floating>
                                      <ColorPicker
                                        color={values.equipmentConfig[index].color}
                                        handleChangeColor={handleChangeColor}
                                        data={values}
                                        index={values.equipmentConfig[index].id}
                                        visibled={false}
                                      />
                                    </Form.Floating>
                                  </Form.Group>
                                </Col>
                              }
                            </Row>
                          )))}
                      </div>)}
                  />
                </Row>

              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};